const USER_COLORS = [
  "#b63bc0",
  "#8508a6",
  "#73919d",
  "#425b65",
  "#fc1a7b",
  "#d2005c",
  "#5b6bc4",
  "#148ad5",
  "#09589f",
  "#179ca8",
  "#138b7a",
  "#58a22b",
  "#064e3f",
  "#1c6b12",
  "#906d62",
  "#613f37",
  "#8553c7",
  "#5728ac",
  "#fc5f1c",
  "#fc3919",
  "#cd1e12",
];
export default class UserUtils {
  public static getUserColor(name: string): string {
    return USER_COLORS[(name.toLowerCase().charCodeAt(0) - 97) % 21];
  }
}
